// English translations
export const en = {
  brand: { name: "Handy Meister", tagline: "Smartphone Repair" },
  nav: {
    home: "Home", repair: "Repair", prices: "Prices",
    appointment: "Book appointment", status: "Repair status",
    shipping: "Mail-in repair", locations: "Locations",
    about: "About us", faq: "FAQ", contact: "Contact", admin: "Admin",
  },
  cta: {
    startRepair: "Start repair", bookAppointment: "Book appointment",
    viewPrices: "View prices", whatsapp: "Ask on WhatsApp",
    selectDevice: "Choose device", showModels: "Show models",
    showRepairs: "Show repairs", select: "Select", next: "Next",
    back: "Back", submit: "Submit", save: "Save", startOver: "Start over",
    sendRequest: "Send repair request", startShipping: "Start mail-in repair",
    savePdf: "Save as PDF",
  },
  hero: {
    title: "Professional smartphone repair.",
    subtitle: "Fast, transparent and reliable.",
    description:
      "Choose your smartphone and the repair service you need. See the estimated price instantly and book an appointment or send a request directly.",
  },
  trust: {
    prices: "Transparent prices", fast: "Fast turnaround",
    quality: "High-quality parts", warranty: "Repair warranty",
    data: "Secure data handling",
  },
  configurator: {
    step1: "Brand", step2: "Model", step3: "Repair",
    step4: "Quality", step5: "Overview", step6: "Book or request",
    selectBrand: "Select brand", selectModel: "Select model",
    selectRepair: "Select repair", selectQuality: "Choose quality",
    summary: "Repair overview",
    searchBrand: "Search brand", searchModel: "Search smartphone model",
    modelNotListed: "My model isn't listed",
    supportedModels: "supported models", startingFrom: "from",
    duration: "Duration", warranty: "Warranty", warrantyMonths: "months warranty",
    minutes: "min", total: "Estimated total",
    subtotal: "Subtotal", comboDiscount: "Combination discount",
    estimatedDuration: "Estimated repair time",
    yourDevice: "Your device", selectedRepairs: "Selected repairs",
    noRepairs: "Please select at least one repair.",
    changeModel: "Change model", addRepair: "Add repair",
    remove: "Remove", change: "Change",
    popularBrands: "Popular brands", allBrands: "All brands",
    apple: "Apple", android: "Android",
  },
  common: {
    loading: "Loading…", empty: "No entries.", error: "An error occurred.",
    required: "Required", yes: "Yes", no: "No", optional: "optional",
    from: "from", from_price: "From", fixed_price: "Fixed price",
    price_on_request: "Price on request", price_after_diagnosis: "Price after diagnosis",
  },
  footer: {
    tagline: "Your professional partner for smartphone repairs in Germany.",
    quickLinks: "Quick links", popularRepairs: "Popular repairs",
    legal: "Legal", contact: "Contact", hours: "Opening hours",
    payment: "Payment methods",
    copyright: "© 2026 Handy Meister. All rights reserved.",
  },
  cookie: {
    title: "This website uses cookies",
    text: "We use necessary cookies to run the site. Optional cookies help us improve our service. You can change your choice at any time.",
    acceptAll: "Accept all", onlyEssential: "Essential only",
    settings: "Settings", necessary: "Necessary",
    statistics: "Statistics", marketing: "Marketing",
    external: "External media", save: "Save selection",
  },
  scarcity: {
    low_stock: "Only a few left in stock",
    out_of_stock: "Currently unavailable — please ask",
    in_stock: "In stock",
  },
};
